import { Component } from "react";
import { Box, CircularProgress, Dialog, DialogTitle, Divider, Grid, Tab, Tabs, Typography } from "@mui/material";
import { Chart as ChartJS } from 'chart.js/auto'
import { Line } from 'react-chartjs-2';
import { getStationHistory } from '../../services/station';
import DownloadContent  from './DownloadContent'

class TableDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      selectedTab: 1,
      data: null,
      selectedData: null
    }
  }

  async componentDidMount() {
    await this.fetchData()
    await this.setChartData()
  }
  
  async fetchData() {
    let data = await getStationHistory(this.props.selectedStn.stn)
    await this.setState({data})
  }

  onCloseModal = async () => {
    this.props.onCloseModal()
  }

  setChartData = async() => {
    let dataset = { 
      labels: this.state.data.label, 
      datasets: [{                    
        fill: true,
        borderColor: "#1976D2",
        backgroundColor: "rgba(64, 156, 236, 0.43)",
      }],
    }
    if(this.state.selectedTab === 1) {
      dataset.datasets[0].data = this.state.data.wl
      dataset.datasets[0].label = "ระดับน้ำ"
    } else if(this.state.selectedTab === 2) {
      dataset.datasets[0].data = this.state.data.rain
      dataset.datasets[0].label = "น้ำฝน"
    } else if(this.state.selectedTab === 3) {
      dataset.datasets[0].data = this.state.data.soil1
      dataset.datasets[0].label = "ความชื้นในดิน"
    } else if(this.state.selectedTab === 5) {
      dataset.datasets[0].data = this.state.data.temperature
      dataset.datasets[0].label = "อุณหภูมิ"
    }
  await this.setState({
    selectedData: dataset
  })

  }

  handleTabChange = async (e, value) => {
    await this.setState({
      selectedTab:value, 
    })
    this.setChartData()
  }

  render() {
    return (
      <Grid>
        <Dialog 
          open={this.props.isModalOpen} 
          onClose={this.props.onCloseModal}   
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>สถานี {this.props.selectedStn.stn} {this.props.selectedStn.name}</DialogTitle>
          <Typography variant="subtitle1" component="div" sx={{ ml: 3, mr: 3}}>ที่ตั้ง {this.props.selectedStn.address}</Typography>
          <Typography variant="subtitle1" component="div" sx={{ ml: 3, mr: 3}}>ข้อมูลล่าสุด ณ วันที่ {this.props.selectedStn.stn_date}</Typography>
          <Divider sx={{pt:2}}/>
          <Tabs 
            value={this.state.selectedTab}
            onChange={this.handleTabChange}
            centered
          >
            <Tab value={1} label="ระดับน้ำ"/>
            <Tab value={2} label="น้ำฝน"/>
            <Tab value={3} label="ความชชื้นในดิน"/>
            <Tab value={5} label="อุณหภูมิ"/>
          </Tabs>
          <Box>
            {this.state.selectedData!==null 
              ? <Line height={200} data={this.state.selectedData}/>
              : <Box alignItems="center" justifyContent="center" sx={{ display: 'flex', mt: 10, mb: 10}}><CircularProgress /></Box>
            }
          </Box>          
          <DownloadContent type="station" stn={this.props.selectedStn.stn}/>
        </Dialog>
      </Grid>
     
    )
  }

}
export default TableDialog;